import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Box
} from '@chakra-ui/react';
import { AdminUsersType } from '../Table/MaintenanceAdminUsersTable';

interface props {
  isOpen: boolean;
  onClose: () => void;
  BrowseData: AdminUsersType | undefined;
}
export const AdminUsersBrowseWindow: React.FC<props> = (props) => {
  const { isOpen, onClose, BrowseData } = props;
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='400px' maxW='1100px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            乗務員の詳細
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody>
            <Box
              position='relative'
              display='grid'
              gridTemplateColumns='1fr 6fr'
            >
              <Text mt={4}>ID</Text>
              <Text mt={4} w='100%'>
                {BrowseData?.id}
              </Text>

              <Text mt={4}>乗務員番号</Text>
              <Text mt={4} w='100%'>
                {BrowseData?.user_no}
              </Text>

              <Text mt={4}>乗務員名</Text>
              <Text mt={4} w='100%'>
                {BrowseData?.name}
              </Text>

              <Text mt={4}>フリガナ</Text>
              <Text mt={4} w='100%'>
                {BrowseData?.kana}
              </Text>

              <Text mt={4}>管理権限</Text>
              <Text mt={4} w='100%'>
                {BrowseData?.role}
              </Text>

              <Text mt={4}>登録日時</Text>
              <Text mt={4} w='100%'>
                {BrowseData?.created_at}
              </Text>

              <Text mt={4}>更新日時</Text>
              <Text mt={4} w='100%'>
                {BrowseData?.updated_at}
              </Text>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
